module.exports = __webpack_public_path__ + "static/img/jiat-special-vehicle.366afab.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/jiat-special-vehicle.jpg
// module id = GN1w
// module chunks = 0